import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'
import { configMenu, accountingMenu } from '../_common/openStackConfigMenu'
import MenuItemWrapper from './MenuItemWrapper'

const MenuWrapper = (props) => {
  const {
    activeTab,
    setActiveTab,
    menuExpandedWidth,
    menuWidth,
    menuExpanded,
    setMenuExpanded,
    showOpenStackServices,
    showAdminUI,
    showCustomerUI,
    showBillingService,
  } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const [filteredConfigMenu, setFilteredConfigMenu] = useState([])

  const menuWrapperStyle = {
    background: theme.palette.azureishWhite,
    borderRadius: '20px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    padding: '12px',
    transition: 'all 0.5s',
  }

  const sectionLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '14px',
    fontWeight: '500',
    padding: '15px 0px',
    textAlign: 'center',
  }  

  const handleToggleMenu = () => {
    setMenuExpanded(prev => !prev)
  }

  useEffect(() => {
    let filtered_config_menu = [...configMenu]
    
    if (!showOpenStackServices) {
      filtered_config_menu = filtered_config_menu.filter(item => item.value !== 'openstack_services')
    }

    if (!showAdminUI && !showCustomerUI) {
      filtered_config_menu = filtered_config_menu.filter(item => item.value !== 'user_interfaces')
    }
    
    if (!showBillingService) {
      filtered_config_menu = filtered_config_menu.filter(item => item.value !== 'billing_service')
    }
    
    setFilteredConfigMenu(filtered_config_menu)
  }, [showOpenStackServices, showAdminUI, showCustomerUI, showBillingService])

  useEffect(() => {
    if (filteredConfigMenu.length > 0) {
      setActiveTab(filteredConfigMenu[0].value)
    } else {
      setActiveTab(null)
    }
  }, [filteredConfigMenu, setActiveTab])

  return (
    <Box
      sx={{
        ...menuWrapperStyle,
        width: menuExpanded ? `${menuExpandedWidth}px` : `${menuWidth}px`
      }}
    >
      {
        width >= constants.lgBreakpoint &&
        <Stack
          direction='row'
          alignItems='flex-start'
          justifyContent={ menuExpanded ? 'flex-end' : 'center' }
          sx={{
            marginBottom: menuExpanded ? '0px' : '10px'
          }}
        >
          <IconButton sx={{ color: theme.palette.oxfordBlue }} onClick={handleToggleMenu}>
            { menuExpanded ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon /> }
          </IconButton>
        </Stack>
      }      

      { menuExpanded && <Box sx={sectionLabelStyle}>{defaultTexts.configuration}</Box> }

      {
        filteredConfigMenu.map((item, index) => (
          <MenuItemWrapper
            key={index}
            {...item}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            menuExpanded={menuExpanded}
          />
        ))
      }

      {
        showBillingService &&
        <>
          {
            menuExpanded &&
            <>
              <Divider sx={{ background: theme.palette.grayX11 }} />
              <Box sx={sectionLabelStyle}>{defaultTexts.accounting}</Box>
            </>
          }

          {
            accountingMenu.map((item, index) => (
              <MenuItemWrapper
                key={index}
                {...item}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                menuExpanded={menuExpanded}
              />
            ))
          }
        </>
      }
      
    </Box>
  )
}

export default MenuWrapper